export const featuredPortfolio = [
  {
    id: 1,
    title: "Food recipe App",
    img: "assets/project1.png",
    site: "https://kind-jones-9d9bb7.netlify.app",
  },
  {
    id: 2,
    title: "Expence Tracker",
    img: "assets/project2.png",
    site: "https://vigorous-goldberg-9458a9.netlify.app",
  },
  {
    id: 3,
    title: "Movie Book",
    img: "assets/movieBooking.png",
    site: "https://vigorous-hoover-a36900.netlify.app",
  },
  {
    id: 4,
    title: "Funiture shop",
    img: "assets/project6.png",
    site: "https://practical-tereshkova-853f57.netlify.app/",
  },
  {
    id: 5,
    title: "Weather App",
    img: "assets/project7.png",
    site: "https://youthful-jackson-6d4fbe.netlify.app/",
  },
];

export const reactPortfolio = [
  {
    id: 1,
    title: "Shopping Website",
    img: "assets/project5.png",
    site: "https://mystifying-swartz-5f1059.netlify.app",
  },
];

export const mobilePortfolio = [
  // {
  //   id: 1,
  //   title: "Mobile Social Media App",
  //   img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
  //   site: "https://google.com",
  // },
  // {
  //   id: 2,
  //   title: "Mobile Rampa UI Design",
  //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  //   site: "#",
  // },
  // {
  //   id: 3,
  //   title: "Mobile E-commerce Design",
  //   img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  //   site: "#",
  // },
  // {
  //   id: 4,
  //   title: "Mobile Relax App",
  //   img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  //   site: "#",
  // },
  // {
  //   id: 5,
  //   title: "Mobile Hero Design",
  //   img: "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
  //   site: "#",
  // },
  // {
  //   id: 6,
  //   title: "Mobile Banking App",
  //   img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
  //   site: "#",
  // },
];
